import { useSelector } from 'react-redux'

import { translate } from '@/utils/translations'

import TableOfContents from '../../../TableOfContents'
import Section from '../Section'

const SECTION_KEY = 'table-of-contents'

const TableOfContentsSection = () => {
  const isOnlineResource = useSelector(state => state.asset.isOnlineResource)

  return(
    <Section
      condition={!isOnlineResource}
      eventKey={SECTION_KEY}
      title={translate('common.table_of_contents')}
    >
      <TableOfContents />
    </Section>
  )
}

export default TableOfContentsSection
